/* eslint-disable jira/filename-case */
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */

import { Component, type ForwardRefExoticComponent, type RefAttributes } from 'react';
import withAnalyticsEvents, {
	type WithAnalyticsEventsProps,
} from '@atlaskit/analytics-next/withAnalyticsEvents';
import type AnalyticsEvent from '@atlaskit/analytics-next/AnalyticsEvent';

type Props = {
	// this prop is coming from Atlaskit, no control over it
	createAnalyticsEvent: (arg1: { action: string }) => AnalyticsEvent;
	onMount: (arg1: AnalyticsEvent) => void;
};

// oxlint-disable-next-line react/prefer-function-component
class MountEventComponent extends Component<Props> {
	componentDidMount() {
		const analyticsEvent = this.props.createAnalyticsEvent({ action: 'mounted' });
		if (this.props.onMount) {
			this.props.onMount(analyticsEvent);
		}
	}

	render() {
		return null;
	}
}

export const MountEvent: ForwardRefExoticComponent<
	Omit<Props, keyof WithAnalyticsEventsProps> & RefAttributes<unknown>
	// @ts-expect-error - TS2345 - Argument of type 'typeof MountEventComponent' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof MountEventComponent) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof MountEventComponent)'.
> = withAnalyticsEvents()(MountEventComponent);
